export const getDataByValue = function (items, value) {
  return items.find(element => element.value === value)
}

export const componentValues = {
  fruitOrYogurt: [
    {
      type: 'image',
      caption: 'fruta',
      value: 'fruta',
      icon: 'fruta.png'
    },
    {
      type: 'image',
      caption: 'yogurt',
      value: 'yogurt',
      icon: 'yogur.png'
    }
  ],
  deposition: [
    {
      type: 'image',
      caption: '0',
      value: '0',
      icon: '0caca.png'
    },
    {
      type: 'image',
      caption: '1',
      value: '1',
      icon: '1caca.png'
    },
    {
      type: 'image',
      caption: '2',
      value: '2',
      icon: '2caca.png'
    },
    {
      type: 'image',
      caption: '3',
      value: '3',
      icon: '3caca.png'
    },
    {
      type: 'image',
      caption: 'Diarrea',
      value: 'diarrea',
      icon: 'malcaca.png'
    },
    {
      type: 'image',
      caption: 'Ausente',
      value: 'ausente',
      icon: 'xcaca.png'
    }
  ],
  nap: [
    {
      type: 'image',
      caption: 'Sí durmió siesta',
      value: 'durmio',
      icon: 'dormido.png'
    },
    {
      type: 'image',
      caption: 'No durmió siesta',
      value: 'no-durmio',
      icon: 'despierto.png'
    },
    {
      type: 'image',
      caption: 'ausente',
      value: 'ausente',
      icon: 'ausente.png'
    }
  ],
  firstCourseType: [
    {
      type: 'image',
      caption: 'PURE',
      value: 'PURE',
      icon: 'pure.png'
    },
    {
      type: 'image',
      caption: 'PURE HUEVO',
      value: 'PURE-HUEVO',
      icon: 'pure-huevo.png'
    },
    {
      type: 'image',
      caption: 'PURE PAVO',
      value: 'PURE-PAVO',
      icon: 'pure-pavo.png'
    },
    {
      type: 'image',
      caption: 'PURE PESCADO',
      value: 'PURE-PESCADO',
      icon: 'pure-pescado.png'
    },
    {
      type: 'image',
      caption: 'PURE POLLO',
      value: 'PURE-POLLO',
      icon: 'pure-pollo.png'
    },
    {
      type: 'image',
      caption: 'PURE TERNERA',
      value: 'PURE-TERNERA',
      icon: 'pure-ternera.png'
    }
  ],
  babyStatus: [
    {
      type: 'image',
      caption: 'todo',
      value: 'todo',
      icon: 'todo.png'
    },
    {
      type: 'image',
      caption: 'mitad',
      value: 'mitad',
      icon: 'mitad.png'
    },
    {
      type: 'image',
      caption: 'nada',
      value: 'nada',
      icon: 'nada.png'
    },
    {
      type: 'image',
      caption: 'Todavía no toma',
      value: 'notoma',
      icon: 'nocome.png'
    },
    {
      type: 'image',
      caption: 'ausente',
      value: 'ausente',
      icon: 'ausente.png'
    }
  ],
  assistence: [
    {
      type: 'image',
      caption: 'asiste',
      value: 'asiste',
      icon: 'asistio.png'
    },
    {
      type: 'image',
      caption: 'ausente',
      value: 'ausente',
      icon: 'ausencia.png'
    }
  ],
  message: [
    {
      type: 'textArea',
      caption: 'mensaje',
      value: 'mensaje',
      icon: 'edit.png'
    }
  ]
}

export default {getDataByValue, componentValues}



// WEBPACK FOOTER //
// ./src/utils/componentsValue.js